// extracted by mini-css-extract-plugin
export default {"typeDropdown":"Diagram_typeDropdown__3nirf","button":"Diagram_button__A3sP2","warning":"Diagram_warning__dddNS"};